<template>
  <b-modal ref="modal" :title="this.$t('logged-vars-overview')" size="md">
    <strong>{{ $t('metrics-overview-for-date-range') }}</strong>
    <p><small>{{ dtFromStr }} - {{ dtToStr }}</small></p>
    <template v-if="loading">
      <div class="d-flex justify-content-center align-items-center">
        <b-spinner style="width: 5rem; height: 5rem;" />
      </div>
    </template>
    <template v-else>
      <template v-if="done">
        <div class="d-flex justify-content-center align-items-center">
          <ul>
            <li v-for="metric in metrics" :key="metric.id">
              {{getVarById(metric.id).placeName}} - {{getVarById(metric.id).serviceName}} / {{ getArgumentName(getVarById(metric.id)) }}: <strong>{{ metric.count }}</strong>
            </li>
          </ul>
        </div>
      </template>
    </template>

    <template v-slot:modal-footer="{ cancel }">
      <b-button @click="hide" variant="secondary">
        {{ $t('close') | capitalize }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import ToasterMixin from "@/mixins/Toaster";
import {mapGetters, mapState} from "vuex";
import config from "@/config";
import axios from "axios";

export default {
  name: "LoggedVarsOverviewModal",
  mixins: [
    ToasterMixin,
  ],
  props: {
    vars: {
      required: true,
      type: Array,
    },
    dtFromStr: {
      required: true,
      type: String,
    },
    dtToStr: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      metrics: [],
      loading: false,
      done: false,
    };
  },
  computed: {
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    ...mapGetters([
      'getVarById',
      'getActorById'
    ]),
  },
  methods: {
    async loadOverview() {
      this.loading = true;
      const url = this.$backendUrl(
        config.ICOOL.API.METRICS_PATH(this.currentSnapshot.id),
      );
      try {
        const response = await axios.post(url, {vars: this.vars, dtFrom: this.dtFromStr, dtTo: this.dtToStr});
        this.metrics = response.data;
      } catch (err) {
        this.$log.error(err);
        this.showToast(this.$t('metrics-overview'), this.$t('error'), 'danger');
      }
      this.done = true;
      this.loading = false;
    },
    show() {
      this.done = false;
      this.loading = false;
      this.loadOverview();
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    getArgumentName(varItem) {
      const actor = this.getActorById(varItem.actorId);
      if (actor && actor.control_group === 'settings') { // FIXME find out bad actor and fix on backend
        if (this.currentSnapshot.rev === 2) {
          return `${varItem.actorsTitle} [${varItem.title}]`;
        }
        return `${varItem.actorsName} [${varItem.description}]`;
      }
      if (this.currentSnapshot.rev === 2) {
        return varItem.title;
      }
      return varItem.actorsName;
    },
  }
};
</script>

<style scoped>

</style>
